// generated by genversion
export var version = '5.0.3';
//# sourceMappingURL=version.js.map